// SummaryBox/TicketsList.tsx

import React from 'react'
import TicketLine from './TicketLine'

type TicketLineData = {
  variant: string
  quantity: number
  price?: number
  normalPrice?: number | null
  hasVoucher?: boolean
  label?: string
  showDiscounts?: boolean
}

export default function TicketsList({ lines }: { lines: TicketLineData[] }) {
  if (!lines.length) return null

  //return <>{JSON.stringify(lines)}</>

  return (
    <>
      {lines.map((line, i) => (
        <TicketLine key={i} {...line} />
      ))}
    </>
  )
}
